import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { serialize } from '../../utility/serialize';
import { Dashboard } from '../../shared/dtos/sale/dashboard.dto';
import { DashboardFilterSet } from '../../shared/dtos/sale/dashboard-filter-set';
import { IDashboardStock } from '../../shared/dtos/sale/dashboard-stock.dto';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery,
  tagTypes: ['Dashboards'],
  endpoints: (builder) => ({
    dashboardData: builder.query<Dashboard, DashboardFilterSet>({
      query: (filterSet) => ({
        url: `/api/dashboards?${serialize(filterSet)}`,
        method: 'GET',
      }),
      providesTags: ['Dashboards'],
    }),
    dashboardStockData: builder.query<IDashboardStock, DashboardFilterSet>({
      query: (filterSet) => ({
        url: `/api/dashboards/stock?${serialize(filterSet)}`,
        method: 'GET',
      }),
      providesTags: ['Dashboards'],
    }),
  }),
});

export const { useDashboardDataQuery, useLazyDashboardDataQuery, useLazyDashboardStockDataQuery } =
  dashboardApi;
